import React from 'react'
import Temp from './Component/Weather/Temp'

const App = () => {
  return (
    <div>
      <Temp/>
    </div>
  )
}

export default App

